import { useList } from '../../../../../../../api/react-query';

export function useMenuConfigList({ params }) {
  const { data, isLoading, refetch, isFetching, isRefetching } = useList(
    'config/empportalMenu/config',
    { ...params },
  );

  return {
    data: data?.data?.data,
    count: data?.data?.totalCount,
    isLoading: isLoading || isFetching || isRefetching,
    refetch,
  };
}
